import e from "./findLastIndex.js";
import r from "./_createIndexFinder.js";
var t = r(-1, e);
export { t as default };